export const buildProductPageUrl = (
  productTitle: string,
  productId: number,
  skuId: number
) => {
  const slug = productTitle
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  const encodedSlug = encodeURIComponent(slug);

  return `/${encodedSlug}/p-${productId}-${skuId}`;
};

export const buildRetailerPageUrl = (
  retailerName: string,
  retailerId: number
) => {
  const slug = retailerName
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  const encodedSlug = encodeURIComponent(slug);

  return `/${encodedSlug}/m-${retailerId}`;
};
